import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";
import Api from "../../Services/Api";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../Action/Tenant/TenantCreatedFetchUser";
import { toastr } from "react-redux-toastr";
import Images from "../../Assets/Images";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { Popup } from "@progress/kendo-react-popup";
import { CircularProgress } from "@material-ui/core";
import { ExcelExport, ExcelExportColumn } from "@progress/kendo-react-excel-export";

import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";

class TenantCreatedFetchUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: "",
      skip: 0,
      take: 10,
      skipD: 0,
      takeD: 10,
      selected: 0,
      loader: false,
      userFetchDataTemp: [],
      deletedUserList: [],
      deletedUserListTemp: [],
      openDeleteModelFlagView: false,
      openrRecycleModelFlagView: false,
      licenseDetails: {
        totalLicences: 0,
        noOfLicenseOnboardUser: 0,
        remainingUser: 0,
      },
      userFetchData: [],
      openResetModelFlagView: false,
      userDetails: {}
    };
  }

  handleSelect = (e) => {
    if (e.selected == 1) {
      this.getDeletedUser();
    }

    this.setState({
      selected: e.selected,
    });
  };

  editUser = async (params) => {
    var token =
      secureLocalStorage.getItem("loggedClient") == "user"
        ? secureLocalStorage.getItem("userKey")
        : secureLocalStorage.getItem("tenantKey");
    var loggedClient = secureLocalStorage.getItem("loggedClient");
    this.props.history.push({
      pathname: `/${loggedClient}/${token}/home/users/add`,
      editUserData: params.dataItem,
    });
  };

  openDeletePopup = (params) => {
    this.setState({
      ...this.state,
      openDeleteModelFlagView: true,
      userId: params.dataItem.userId,
    });
  };
  closeDeletePopup = () => {
    this.setState({
      ...this.state,
      openDeleteModelFlagView: false,
      openResetModelFlagView:false,
      userDetails:{},
      loader: false
    });
  };

  
  componentDidMount() {
    this.getUserList();
    this.availableUsers();
  }
  getUserList = async () => {
    let tenantKey = secureLocalStorage.getItem("tenantKey");
    let params = {
      TenantKey: tenantKey,
    };
    const { actions } = this.props;
    await actions.FetchUserGridData(params);

    this.setState({
      userFetchData: this.props.userFetchData,
      userFetchDataTemp: this.props.userFetchData,
    });
  };

  pageChange = (event) => {
    this.setState({
      skip: event.page.skip,
      take: event.page.take,
    });
  };

  pageChangeD = (event) => {
    this.setState({
      skipD: event.page.skip,
      takeD: event.page.take,
    });
  };
  searchUser = (keyword) => {
    const filtered = this.state.userFetchDataTemp.filter((entry) =>
      Object.values(entry).some(
        (val) =>
          typeof val === "string" &&
          val.toLocaleLowerCase().includes(keyword.toLocaleLowerCase())
      )
    );
    this.setState({ ...this.state, userFetchData: filtered });
  };

  searchDeletedUser = (keyword) => {
    const filtered = this.state.deletedUserListTemp.filter((entry) =>
      Object.values(entry).some(
        (val) =>
          typeof val === "string" &&
          val.toLocaleLowerCase().includes(keyword.toLocaleLowerCase())
      )
    );
    this.setState({ ...this.state, deletedUserList: filtered });
  };
  deleteUser = async () => {
    try {
      var requestParams = {
        UserId: this.state.userId,
        DeletedBy: parseInt(secureLocalStorage.getItem("loginUserId")),
      };
      this.setState({ ...this.state, loader: true });

      let response = await Api.deleteUser(requestParams);
      this.setState({ ...this.state, loader: false });
      if (response.status === 200) {
        toastr.success(response.message);
        this.closeDeletePopup();
        this.getUserList();
        this.availableUsers();
        // this.getDeletedUser();
      } else {
        toastr.error(response.message);
      }
    } catch (error) {
      this.setState({ ...this.state, loader: false });
    }
  };

  getDeletedUser = async () => {
    try {
      this.setState({ ...this.state, loader: true });

      let response = await Api.getDeletedUser();
      this.setState({ ...this.state, loader: false });
      if (response.status === 200) {
        this.setState({
          ...this.state,
          deletedUserList: response.tenantUsers,
          deletedUserListTemp: response.tenantUsers,
        });
      } else {
        this.setState({
          ...this.state,
          deletedUserList: [],
          deletedUserListTemp: [],
        });
      }
    } catch (error) {
      this.setState({
        ...this.state,
        loader: false,
        deletedUserList: [],
        deletedUserListTemp: [],
      });
    }
  };

  openRecyclePopup = (params) => {
    this.setState({
      ...this.state,
      openrRecycleModelFlagView: true,
      userId: params.dataItem.userId,
    });
  };
  closeRecyclePopup = () => {
    this.setState({
      ...this.state,
      openrRecycleModelFlagView: false,
    });
  };

  recycleUser = async () => {
    try {
      this.setState({ ...this.state, loader: true });
      let req = {
        Userid: this.state.userId,
      };
      let response = await Api.RecycleUser(req);
      this.setState({ ...this.state, loader: false });
      if (response.status === 200) {
        this.closeRecyclePopup();
        toastr.success(response.message);
        this.getDeletedUser();
        this.getUserList();
        this.availableUsers();
      } else {
        toastr.error(response.message);
      }
    } catch (error) {
      this.setState({
        ...this.state,
        loader: false,
      });
    }
  };
  availableUsers = async () => {
    try {
      this.setState({ ...this.state, loader: true });

      let response = await Api.AvailableUsers();
      this.setState({ ...this.state, loader: false });
      if (response.status === 200) {
        this.setState({ ...this.state, licenseDetails: response });
      } else {
        this.setState({
          ...this.state,
          licenseDetails: {
            totalLicences: 0,
            noOfLicenseOnboardUser: 0,
            remainingUser: 0,
          },
        });
      }
    } catch (error) {
      this.setState({
        ...this.state,
        loader: false,
      });
    }
  };

  generateNewPassword = async (dataItem) => {
    try {
      this.setState({ ...this.state, loader: true });
      let response = await Api.UserPasswordReset(dataItem);
      if (response.status === 200) {
        toastr.success(response.message);
        this.closeDeletePopup();
      } else {
        toastr.error(response.message);
        this.setState({ ...this.state, loader: false });

      }
    } catch (error) {
      this.setState({
        ...this.state,
        loader: false,
      });
    }
  };
  openResetModelPopup=(dataItem)=>{
    this.setState({
      ...this.state,
      openResetModelFlagView:true,
      userDetails:dataItem
    });
  }
  // Prepare data for Risk User List with one row per workstream
  prepareRiskExcelData = () => {
    if (!this.state.userFetchData || this.state.userFetchData.length === 0) {
      return [];
    }
    
    const excelData = [];
    
    this.state.userFetchData.forEach(user => {
      if (!user) return;
      console.log("user",user);
      // Determine user type
      let userType = "User";
      if (user.isSuperAdmin) {
        userType = "Super Admin";
      } else if (user.isTenantAdmin) {
        userType = "Tenant Admin";
      } 
      // else {
      //   userType = user.role || "User";
      // }
      
      // Common user data
      const userData = {
        "USER NAME": user.name || "",
        "USER TYPE": userType,
        "TELEPHONE": user.telephone || "",
        "EMAIL": user.emailAddress || ""
      };
      
      // Handle users with admin privileges that have access to all workstreams
      if (user.isTenantAdmin || user.isSuperAdmin) {
        excelData.push({
          ...userData,
          "ROLE": "Tenant Admin",
          "WORKSTREAM NAME": "All Workstreams"
        });
      }
      // Handle users with workstream roles
      else if (user.workstreamRoles && user.workstreamRoles.length > 0) {
        user.workstreamRoles.forEach(workstream => {
          // Skip rows where role is empty or "None"
          if (workstream.role && workstream.role !== "") {
            excelData.push({
              ...userData,
              "ROLE": workstream.role,
              "WORKSTREAM NAME": workstream.workstreamName || ""
            });
          }
        });
      }
      // No longer adding empty rows for users with no workstreams
    });
    
    return excelData;
  }

  // Prepare data for Task User List with one row per workstream
  prepareTaskExcelData = () => {
    if (!this.state.userFetchData || this.state.userFetchData.length === 0) {
      return [];
    }
    
    const excelData = [];
    
    this.state.userFetchData.forEach(user => {
      if (!user) return;
      
      // Determine user type
      let userType = "User";
      if (user.isSuperAdmin) {
        userType = "Super Admin";
      } else if (user.isTenantAdmin) {
        userType = "Tenant Admin";
      } 
      // else {
      //   userType = user.role || "User";
      // }
      
      // Common user data
      const userData = {
        "USER NAME": user.name || "",
        "USER TYPE": userType,
        "TELEPHONE": user.telephone || "",
        "EMAIL": user.emailAddress || ""
      };
      
      // Handle users with admin privileges that have access to all workstreams
      if (user.isTenantAdmin || user.isSuperAdmin) {
        excelData.push({
          ...userData,
          "ROLE": "Tenant",
          "WORKSTREAM NAME": "All Workstreams"
        });
      }
      // Handle users with workstream roles
      else if (user.workstreamRoles && user.workstreamRoles.length > 0) {
        user.workstreamRoles.forEach(workstream => {
          // Skip rows where taskRole is empty or "None"
          if (workstream.taskRole && workstream.taskRole !== "") {
            excelData.push({
              ...userData,
              "ROLE": workstream.taskRole,
              "WORKSTREAM NAME": workstream.workstreamName || ""
            });
          }
        });
      }
      // No longer adding empty rows for users with no workstreams
    });
    
    return excelData;
  }

  // Export to Excel handler
  exportToExcel = () => {
    try {
      if (this._exporter) {
        // Define common cell styles
        const headerStyle = {
          background: "#005F62", // Green background matching Riskwell theme
          color: "#ffffff", // White text
          bold: true,
          fontSize: 12,
          wrap: true,
          textAlign: "center",
          verticalAlign: "center",
          borderBottom: { color: "#000000", size: 1 },
          borderTop: { color: "#000000", size: 1 },
          borderLeft: { color: "#000000", size: 1 },
          borderRight: { color: "#000000", size: 1 }
        };

        const dataCellStyle = {
          wrap: true,
          textAlign: "left",
          verticalAlign: "top",
          borderBottom: { color: "#cccccc", size: 1 },
          borderLeft: { color: "#cccccc", size: 1 },
          borderRight: { color: "#cccccc", size: 1 }
        };

        // Column widths
        const columnWidths = [
          { width: 200 }, // USER NAME
          { width: 150 }, // USER TYPE
          // { width: 150 }, // TELEPHONE
          { width: 250 }, // EMAIL
          { width: 150 }, // ROLE
          { width: 200 }  // WORKSTREAM NAME
        ];

        // Create a workbook with two sheets
        const workbookOptions = {
          sheets: [
            {
              name: "Risk User List",
              columns: columnWidths,
              freezePane: { rowSplit: 1 }, // Freeze header row
              rows: [
                // Header row
                {
                  height: 30,
                  cells: [
                    { value: "USER NAME", ...headerStyle },
                    { value: "USER TYPE", ...headerStyle },
                    // { value: "TELEPHONE", ...headerStyle },
                    { value: "EMAIL", ...headerStyle },
                    
                    { value: "WORKSTREAM NAME", ...headerStyle },
                    { value: "ROLE", ...headerStyle }
                  ]
                },
                // Data rows for Risk sheet
                ...this.prepareRiskExcelData().map(item => ({
                  height: 25,
                  cells: [
                    { value: item["USER NAME"], ...dataCellStyle },
                    { value: item["USER TYPE"], ...dataCellStyle },
                    // { value: item["TELEPHONE"], ...dataCellStyle },
                    { value: item["EMAIL"], ...dataCellStyle },
                    
                    { value: item["WORKSTREAM NAME"], ...dataCellStyle },
                    { value: item["ROLE"], ...dataCellStyle }
                  ]
                }))
              ]
            },
            {
              name: "Task User List",
              columns: columnWidths,
              freezePane: { rowSplit: 1 }, // Freeze header row
              rows: [
                // Header row
                {
                  height: 30,
                  cells: [
                    { value: "USER NAME", ...headerStyle },
                    { value: "USER TYPE", ...headerStyle },
                    // { value: "TELEPHONE", ...headerStyle },
                    { value: "EMAIL", ...headerStyle },
                    
                    { value: "WORKSTREAM NAME", ...headerStyle },
                    { value: "ROLE", ...headerStyle }
                  ]
                },
                // Data rows for Task sheet
                ...this.prepareTaskExcelData().map(item => ({
                  height: 25,
                  cells: [
                    { value: item["USER NAME"], ...dataCellStyle },
                    { value: item["USER TYPE"], ...dataCellStyle },
                    // { value: item["TELEPHONE"], ...dataCellStyle },
                    { value: item["EMAIL"], ...dataCellStyle },
                    
                    { value: item["WORKSTREAM NAME"], ...dataCellStyle },
                    { value: item["ROLE"], ...dataCellStyle }
                  ]
                }))
              ]
            }
          ]
        };
        
        this._exporter.save(workbookOptions);
      }
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      toastr.error("Failed to export to Excel. Please try again.");
    }
  }

  render() {
    let email = secureLocalStorage.getItem("setEmail");
    return (
      <div className="tblCont dataGrids userList" style={{ padding: "0px" }}>
        {/* Excel Export Component */}
        <ExcelExport
          fileName="Active_User_List.xlsx"
          ref={(exporter) => { this._exporter = exporter; }}
          creator="Riskwell"
          title="Active User List"
        >
          <ExcelExportColumn field="USER NAME" title="USER NAME" width="200px" />
          <ExcelExportColumn field="USER TYPE" title="USER TYPE" width="150px" />
          {/* <ExcelExportColumn field="TELEPHONE" title="TELEPHONE" width="150px" />
          // <ExcelExportColumn field="EMAIL" title="EMAIL" width="250px" /> */}
          <ExcelExportColumn field="WORKSTREAM NAME" title="WORKSTREAM NAME" width="200px" />
          <ExcelExportColumn field="ROLE" title="ROLE" width="150px" />
          
        </ExcelExport>
        
        <TabStrip selected={this.state.selected} onSelect={this.handleSelect}>
          <TabStripTab title="Active User">
            <div>
              <div
                className="gridHeader"
                style={{ backgroundColor: "#1f2222" }}
              >
                <div className="d-flex align-items-center">
                  <h4>User List</h4>
                  <ul className="userLicensescount">
                    <li>
                      <span>
                        Total Licences:{this.state.licenseDetails.totalLicences}
                      </span>
                    </li>
                    <li>
                      <span>
                        Active Licences:
                        {this.state.licenseDetails.noOfLicenseOnboardUser}
                      </span>
                    </li>
                    <li>
                      <span>
                        Remaining Licences:
                        {this.state.licenseDetails.remainingUser}
                      </span>
                    </li>
                  </ul>

                  <div className="ml-auto d-flex">
                    <div style={{ marginRight: "10px",marginTop: "4px" }}>
                      {/* <button
                        onClick={this.exportToExcel}
                        title="Export to Excel"
                      > */}
                       <a onClick={this.exportToExcel} title="Export User List">
                        <img
                          src={Images.XLSX}
                          width="18"
                          alt="Export to Excel"
                        />
                        </a>
                      {/* </button> */}
                    </div>
                    <div className="btnGreen">
                      <button
                        onClick={() =>
                          this.props.history.push(
                            `/${secureLocalStorage.getItem(
                              "loggedClient"
                            )}/${secureLocalStorage.getItem(
                              "tenantKey"
                            )}/home/users/add`
                          )
                        }
                      >
                        Add User
                      </button>
                    </div>
                    <div className="searchBox">
                      <span className="searchIcon">
                        <img src={Images.SEARCHICON} width="12" alt="Search" />
                      </span>
                      <input
                        type="text"
                        placeholder="Search"
                        name="search"
                        onChange={(e) => this.searchUser(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="rw-tab-content">
                <Grid
                  data={
                    this.state.userFetchData &&
                    this.state.userFetchData.slice(
                      this.state.skip,
                      this.state.take + this.state.skip
                    )
                  }
                  skip={this.state.skip}
                  take={this.state.take}
                  total={
                    this.state.userFetchData && this.state.userFetchData.length
                  }
                  pageable={true}
                  onPageChange={this.pageChange}
                  sortable={true}
                  resizable={true}
                  reorderable={true}
                >
                  <Column field="name" title="USER NAME" />
                  <Column
                    field="type"
                    title="USER TYPE"
                    cell={(props) => (
                      <td>
                        {props.dataItem.isSuperAdmin
                          ? "Super Admin"
                          : props.dataItem.isTenantAdmin
                          ? "Tenant Admin"
                          : "User"}
                      </td>
                    )}
                  />
                  <Column field="telephone" title="TELEPHONE" width="200" />
                  <Column field="emailAddress" title="EMAIL" />
                  <Column
                    field="workStreamNames"
                    title="Workstreams"
                    cell={(props) => (
                      <td>
                        <div>
                          {props.dataItem.workstreamRoles &&
                            props.dataItem.workstreamRoles.map(
                              (item, index) => (
                                <span title={item.role}>
                                  {item.workstreamName}
                                  {props.dataItem.workstreamRoles.length - 1 !=
                                  index
                                    ? ","
                                    : ""}
                                </span>
                              )
                            )}
                          {props.dataItem.isTenantAdmin ||
                          props.dataItem.isSuperAdmin
                            ? "All Workstreams"
                            : ""}
                        </div>
                      </td>
                    )}
                  />
                  <Column
                    field="isEnabled"
                    title="ENABLE/DISABLE"
                    width="120"
                    cell={(props) => (
                      <>
                        {props.dataItem.emailAddress != email &&
                          !props.dataItem.isSuperAdmin &&
                          AgGridCheckbox(props, this.getUserList)}
                      </>
                    )}
                  />
                  <Column
                    // field=""
                    title="ACTION"
                    width="80"
                    cell={(props) => (
                      <td>
                        {props.dataItem.emailAddress != email &&
                          !props.dataItem.isSuperAdmin && (
                            <div className="proBtnGroup">
                              <button
                                className="actionCellCont"
                                onClick={() => this.editUser(props)}
                              >
                                <img src={Images.EDITICON} width="10" />
                              </button>
                              &nbsp;&nbsp;
                              <button
                                className="actionCellCont"
                                onClick={() => this.openDeletePopup(props)}
                              >
                                <img src={Images.TRASH} width="10" />
                              </button>
                            </div>
                          )}
                      </td>
                    )}
                  />
                  {/* <Column
                    // field=""
                    title="Reset"
                    width="150"
                    cell={(props) => (
                      <td>
                        {props.dataItem.emailAddress != email &&
                          !props.dataItem.isSuperAdmin && (
                            <a
                              className="genPassword"
                              style={{ color: "#009660" }}
                              onClick={() =>
                                this.openResetModelPopup(props.dataItem)
                              }
                            >
                              Reset Password
                            </a>
                          )}
                      </td>
                    )}
                  /> */}
                </Grid>
              </div>
            </div>
          </TabStripTab>
          <TabStripTab title="Deleted User">
            <div>
              <div
                className="gridHeader"
                style={{ backgroundColor: "#1f2222" }}
              >
                <div className="d-flex align-items-center">
                  <h4>Deleted Users</h4>
                  <div className="ml-auto d-flex">
                    <div className="searchBox">
                      <span className="searchIcon">
                        <img src={Images.SEARCHICON} width="12" alt="Search" />
                      </span>
                      <input
                        type="text"
                        placeholder="Search"
                        name="search"
                        onChange={(e) => this.searchDeletedUser(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="rw-tab-content">
                <Grid
                  data={
                    this.state.deletedUserList &&
                    this.state.deletedUserList.slice(
                      this.state.skipD,
                      this.state.takeD + this.state.skipD
                    )
                  }
                  skip={this.state.skipD}
                  take={this.state.takeD}
                  total={
                    this.state.deletedUserList &&
                    this.state.deletedUserList.length
                  }
                  pageable={true}
                  onPageChange={this.pageChangeD}
                  sortable={true}
                >
                  <Column field="name" title="USER NAME" />
                  <Column
                    field="type"
                    title="USER TYPE"
                    cell={(props) => (
                      <td>
                        {props.dataItem.isTenantAdmin ? "Tenant Admin" : "User"}
                      </td>
                    )}
                  />
                  <Column field="telephone" title="TELEPHONE" width="200" />
                  <Column field="emailAddress" title="EMAIL" />
                  <Column
                    field="workStreamNames"
                    title="Workstreams"
                    cell={(props) => (
                      <td>
                        <div>
                          {props.dataItem.workstreamRoles &&
                            props.dataItem.workstreamRoles.map(
                              (item, index) => (
                                <span title={item.role}>
                                  {item.workstreamName}
                                  {props.dataItem.workstreamRoles.length - 1 !=
                                  index
                                    ? ","
                                    : " "}
                                </span>
                              )
                            )}
                        </div>
                      </td>
                    )}
                  />
                  <Column
                    // field=""
                    title="ACTION"
                    width="80"
                    cell={(props) => (
                      <td>
                        <div className="proBtnGroup">
                          <button
                            title="Recycle User"
                            className="actionCellCont"
                            onClick={() => this.openRecyclePopup(props)}
                          >
                            <img src={Images.RECYCLE} width="14" />
                          </button>
                        </div>
                      </td>
                    )}
                  />
                </Grid>
              </div>
            </div>
          </TabStripTab>
        </TabStrip>

        <Popup
          show={this.state.openDeleteModelFlagView}
          popupClass={"popup-content"}
        >
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <div className="deleteModelCont">
            <h3>Are you sure you want to delete this user?</h3>
            <div className="btnCont">
              <button
                onClick={() => this.deleteUser()}
                className="deleteBtn"
                type="button"
              >
                Delete
              </button>
              <button
                onClick={this.closeDeletePopup}
                className="cancelBtn"
                type="button"
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>

        <Popup
          show={this.state.openrRecycleModelFlagView}
          popupClass={"popup-content"}
        >
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <div className="deleteModelCont">
            <h3>Do you want to re-induct this user?</h3>
            <div className="btnCont">
              <button
                onClick={() => this.recycleUser()}
                className="deleteBtn"
                type="button"
              >
                Confirm
              </button>
              <button
                onClick={this.closeRecyclePopup}
                className="cancelBtn"
                type="button"
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>
      
        <Popup
          show={this.state.openResetModelFlagView}
          popupClass={"popup-content"}
        >
          {this.state.loader ? (
            <span className="MatTableSpinner">
              <CircularProgress style={{ color: "#FFFFFF" }} size={70} />
            </span>
          ) : null}
          <div className="deleteModelCont">
            <h3>Are you sure you want to reset this user's password?</h3>
            <div className="btnCont">
              <button
                onClick={() => this.generateNewPassword(this.state.userDetails)}
                className="deleteBtn"
                type="button"
              >
                Reset
              </button>
              <button
                onClick={this.closeDeletePopup}
                className="cancelBtn"
                type="button"
              >
                Cancel
              </button>
            </div>
          </div>
        </Popup>
      </div>
    );
    // } else {
    //   return <div>No Records Found ...!</div>;
    // }
  }

  _exporter;
}

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => {
  return {
    userFetchData: state.TenantCreatedFetchUser.userData,
  };
};

function AgGridCheckbox(params, getFunction) {
  const [isChecked, setIsChecked] = React.useState(
    params.dataItem.isEnabled === true ? true : false
  );

  const onChanged = async () => {
    var request = {
      tenantKey: secureLocalStorage.getItem("tenantKey"),
      userId: params.dataItem.userId.toString(),
      tenantEmail: params.dataItem.emailAddress,
      IsEnabled: !isChecked,
    };
    setIsChecked(!isChecked);
    let response = await Api.enableUser(request);
    if (response.status === 200) {
      toastr.success(response.message);
      getFunction();
    } else {
      setIsChecked(!isChecked);
      toastr.error("Failed");
    }
  };
  return (
    <td>
      <label className="switch">
        <input type="checkbox" checked={isChecked} onChange={onChanged} />
        <span className="slider"></span>
      </label>
    </td>
  );
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TenantCreatedFetchUser);
